module.exports = __webpack_public_path__ + "img/creditcard.a7cff433.png";